import { images, resort } from "@/data/resort";
import { ResortLink } from "../resort-button";

export function ContactFinalCTA() {
  return (
    <section aria-labelledby="contact-final-cta-heading" className="relative overflow-hidden bg-primary py-16 md:py-20">
      <div className="overlay-cinematic absolute inset-0" />
      <div className="shell relative max-w-3xl text-center text-primary-foreground">
        <p className="eyebrow text-primary-foreground/75">Ready to Stay?</p>
        <h2 id="contact-final-cta-heading" className="display-lg mt-6">
          Your Auburn Adventure Starts Here
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-primary-foreground/80">
          Choose your dates, tell us about your RV and let Auburn RV Resort help you find the right
          available site.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
          <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
            Check Availability
          </ResortLink>
          <ResortLink variant="onDark" href={resort.phoneHref} className="w-full sm:w-auto">
            Call {resort.phone}
          </ResortLink>
        </div>
        <p className="eyebrow mt-8 text-primary-foreground/60">
          Daily · Weekly · Monthly · Full Hookups · Pet Friendly
        </p>
      </div>
    </section>
  );
}
